import { useContext } from 'react';
import { type QuickView, QuickViewContext } from '../QuickViewProvider.tsx';

export const useQuickView = (): QuickView => {
    const context = useContext(QuickViewContext);
    // This is okay to return object if context is missing. Item Tile can be used without QuickViewProvider.
    return context || {};
};
